export enum LoginStep {
  CPF = 'CPF',
  CODE_METHOD = 'CODE_METHOD',
  CODE = 'CODE',
  SUCCESS = 'SUCCESS'
}

export enum ResendFeedback {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}
